import React from 'react';
import styled from 'styled-components';

import { Chip } from '@column/column-ui-kit';

const CounterCellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 100%;
`;

const Counter = styled(Chip)`
  --chip-font-size: 11px;
  padding-left: 0px;
  padding-right: 0px;
  justify-content: center;
  min-width: 24px;
`;

export const CounterCell = ({ value }: { value: number }) => {
  return (
    <CounterCellWrapper>
      <Counter>{value}</Counter>
    </CounterCellWrapper>
  );
};
